import React from 'react'
import PropTypes from 'prop-types'

const TenantActions = ({
  title,
  provider,
  position,
  isEditable,
  editButtonLabel,
  isEditing,
  isWhitelisted,
  isUserDeveloper,
  isTDMSAdmin,
  onEditClick,
  onMembersClick,
  onLogsClick,
  onBookingsClick,
  onDeleteClick,
  onComplianceInfoClick,
  onAkamaiCacheInvalidation,
  onChangeProviderClick,
}) => {
  const dropDownMenu = [
    {
      component: () => (
        <button
          type="button"
          className="wb-list-group__item"
          aria-label="Edit Tenant"
          onClick={onBookingsClick}
        >
          <wb-icon name="edit" class="wb-list-group__item-icon"></wb-icon>
          Bookings
        </button>
      ),
      visible: !isEditing,
    },
    {
      component: () => (
        <button
          type="button"
          className="wb-list-group__item"
          aria-label="Edit Tenant"
          onClick={onComplianceInfoClick}
        >
          <wb-icon
            name="bds/pencil-document/24"
            class="wb-list-group__item-icon"
          ></wb-icon>
          Compliance Information
        </button>
      ),
      visible: !isEditing,
    },
    {
      component: () => (
        <button
          type="button"
          className="wb-list-group__item"
          aria-label="Tenant Logs"
          onClick={onLogsClick}
        >
          <wb-icon
            name="bds/statistics/24"
            class="wb-list-group__item-icon"
          ></wb-icon>
          Logs
        </button>
      ),
      visible: !isEditing,
    },
    {
      component: () => (
        <button
          type="button"
          className="wb-list-group__item"
          onClick={onAkamaiCacheInvalidation}
        >
          <wb-icon
            name="bds/reset/24"
            class="wb-list-group__item-icon"
          ></wb-icon>
          Invalidate CDN Caches
        </button>
      ),
      visible: !isEditing,
    },
    {
      component: () => (
        <button
          type="button"
          className="wb-list-group__item"
          onClick={onChangeProviderClick}
        >
          <wb-icon
            name="bds/download-print/24"
            class="wb-list-group__item-icon"
          ></wb-icon>
          Change Provider
        </button>
      ),
      visible: isTDMSAdmin,
    },
    {
      component: () => (
        <button
          type="button"
          aria-label="Delete Tenant"
          className="wb-list-group__item"
          onClick={onDeleteClick}
        >
          <wb-icon
            name="delete"
            aria-hidden="true"
            class="wb-list-group__item-icon"
          ></wb-icon>
          Remove Tenant
        </button>
      ),
      visible: !isEditing && isWhitelisted && isTDMSAdmin,
    },
  ]
  const buttonGroup = [
    {
      component: () => (
        <button
          type="button"
          aria-label="Edit Tenant"
          className="wb-button wb-button--theme-dark wb-button--secondary wb-button--small edit"
          onClick={onAkamaiCacheInvalidation}
        >
          Invalidate CDN Caches
        </button>
      ),
      visible: !(!isEditing && isWhitelisted) && isUserDeveloper,
    },
    {
      component: () => (
        <button
          type="button"
          aria-label="Edit Tenant"
          className="wb-button wb-button--theme-dark wb-button--secondary wb-button--small edit"
          onClick={onEditClick}
        >
          <wb-icon
            name="edit"
            aria-hidden="true"
            class="wb-button__icon"
          ></wb-icon>
          {editButtonLabel}
        </button>
      ),
      visible: !isEditing && isEditable,
    },
    {
      component: () => (
        <button
          type="button"
          aria-label="Edit Tenant"
          className="wb-button wb-button--theme-dark wb-button--secondary wb-button--small edit"
          onClick={onMembersClick}
        >
          <wb-icon
            name="edit"
            aria-hidden="true"
            class="wb-button__icon"
          ></wb-icon>
          Members
        </button>
      ),
      visible: !isEditing && isEditable,
    },
    {
      component: () => (
        <wb-popover-host position="top">
          <button
            className="wb-button wb-button--theme-dark wb-button--secondary wb-button--small wb-button--icon-only delete"
            aria-label="Open Popover Menu"
            type="button"
          >
            <wb-icon
              name="bds/more/24"
              aria-hidden="true"
              class="wb-button__icon"
            ></wb-icon>
          </button>
          <wb-popover style={{ maxHeight: 'unset' }}>
            <div className="wb-list-group">
              {dropDownMenu.map(
                ({ component: Component, visible }, index) =>
                  visible && <Component key={index} />,
              )}
            </div>
          </wb-popover>
        </wb-popover-host>
      ),
      visible: !isEditing && isEditable,
    },
  ]

  return (
    <div className={`tenant-actions tenant-actions--${position}`}>
      {position == 'top' && (
        <h2 className="tenant-actions__title">
          {title ? (
            <>
              {title} <sup>[{provider}]</sup>
            </>
          ) : (
            'New Tenant'
          )}
        </h2>
      )}
      <div className="tenant-actions__buttons">
        <wb-button-group>
          {buttonGroup.map(
            ({ component: Component, visible }, index) =>
              visible && <Component key={index} />,
          )}
        </wb-button-group>
      </div>
    </div>
  )
}

TenantActions.propTypes = {
  title: PropTypes.string,
  provider: PropTypes.string,
  position: PropTypes.string,
  isEditable: PropTypes.bool,
  editButtonLabel: PropTypes.string,
  isEditing: PropTypes.bool,
  isWhitelisted: PropTypes.bool,
  isUserDeveloper: PropTypes.bool,
  isTDMSAdmin: PropTypes.bool,
  onEditClick: PropTypes.func,
  onMembersClick: PropTypes.func,
  onLogsClick: PropTypes.func,
  onBookingsClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onComplianceInfoClick: PropTypes.func,
  onAkamaiCacheInvalidation: PropTypes.func,
  onChangeProviderClick: PropTypes.func,
}
export default TenantActions
